import { createStore } from 'stimulus-store';

/**
 * Store for all devices fetched from the server.
 * 
 * Store States:
 * - []: Empty array can mean either:
 *   - Devices have not been loaded yet (check devicesLoadingStore)
 *   - Devices have been loaded, but organization has no devices
 * - [...]: Devices have been loaded and exist
 * 
 * Use devicesLoadingStore to distinguish between "not loaded yet" and "loaded but empty".
 * This pattern allows controllers to determine whether to wait for data loading
 * or proceed with filtering an empty dataset.
 */
export const allDevicesStore = createStore({
    name: 'allDevicesStore',
    type: Array,
    initialValue: []
});